import React, { useEffect, useState } from 'react';
import Header from '@components/Comman/Header';
import { Table, Tag, Button, Space, Spin, Empty, message } from 'antd';
import { BankOutlined, EyeOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { useDispatch } from 'react-redux';
import { exportMyReferralsAction, getAllSuperAdminReferrals, getMyRefferalAction, getReferrerNotificationCount, paySuperAdminReferrals, sendEmailToTheReferrerAction, updateReferrerNotificationCount } from '../../actions/refer';
import { useSelector } from 'react-redux';
import moment from 'moment';
import SearchFilter from '@components/Comman/TableFilter/SearchFilter';
import PageTitle from '@components/Comman/PageTitle';
// import { capitalizeAfterComma, capitalizeFirstLetter, truncateText } from '@utils/comman';
import PaymentModal from '../Acount/PaymentModal';
import { referralFilterList } from '@utils/contstant';
import { Link } from 'react-router-dom';
import CardPagination from '@components/Comman/CardPagination';
import ListingCardReferrer from '@components/Comman/ListingCardReferrer/ListingCardReferrer';
import { convertToReferralBusinessFormat } from '@utils/comman';
import SuperAdminPaymentModal from '@components/Comman/SuperAdminPaymentModal';

interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    email: string;
    businessCode: string;
    isRegistered: boolean;
}

interface PayloadType {
    limit: number;
    page: number;
    isReferral: number;
    role: number;
    admin_id?: number;
};

interface ReferralsType {
    adminId?: number
}

const Referrals = ({ adminId }: ReferralsType) => {
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state: any) => state?.General);
    const userData = useSelector((state: any) => state?.Auth?.user);
    // const navigate = useNavigate();

    const [data, setData] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState({ totalItems: 0 });
    const [pageSize, setPageSize] = useState(12);
    const [page, setPage] = useState(1);
    const [showPaymentModal, setShowPaymentModal] = useState({show: false, data: {}});
    const [showSuperAdminPaymentModal, setShowSuperAdminPaymentModal] = useState({show: false, data: {}});
    const userRoleId = userData?.data?.roleId;
    let pageName =location?.pathname?.split('/')?.[2];
    let showOnlyTable = userRoleId === 1 && pageName === 'view-business-details'

    // Helper function to render outcomes based on roleId
    const renderOutcomeByRole = (outcome: string) => {
        if (userRoleId === 1) {
            // For roleId 1, show only pending initially, then successful after payment
            return (
                <>
                    {outcome === 'success' ? <Tag color='green' style={{ fontSize: '9px'}}>Successful</Tag> : ""}
                    {outcome === 'pending' ? <Tag color='orange' style={{ fontSize: '9px'}}>Pending</Tag> : ""}
                </>
            );
        } else if (userRoleId === 2) {
            // For roleId 2, keep existing outcomes
            return (
                <>
                    {outcome === 'success' ? <Tag color='green' style={{ fontSize: '9px'}}>Successful</Tag> : ""}
                    {outcome === 'fail' ? <Tag color='red' style={{ fontSize: '9px'}}>Un-Successful</Tag> : ""}
                    {outcome === 'pending' ? <Tag color='yellow' style={{ fontSize: '9px'}}>Pending</Tag> : ""}
                    {outcome === 'acknowledged' ? <Tag color='orange' style={{ fontSize: '9px'}}>Acknowledged</Tag> : ""}
                    {outcome === 'contacted' ? <Tag color='blue' style={{ fontSize: '9px'}}>Contacted</Tag> : ""}
                    {outcome === 'qualified' ? <Tag color='blue' style={{ fontSize: '9px'}}>Qualified</Tag> : ""}
                    {outcome === 'not_a_fit' ? <Tag color='gray' style={{ fontSize: '9px'}}>Not a Fit</Tag> : ""}
                    {outcome === 'completed' ? <Tag color='orange' style={{ fontSize: '9px'}}>Completed</Tag> : ""}
                </>
            );
        } else if (userRoleId === 3) {
            // For roleId 3, show only acknowledged and successful/unsuccessful
            return (
                <>
                    {outcome === 'acknowledged' ? <Tag color='orange' style={{ fontSize: '9px'}}>Acknowledged</Tag> : ""}
                    {outcome === 'success' ? <Tag color='green' style={{ fontSize: '9px'}}>Successful</Tag> : ""}
                    {outcome === 'fail' ? <Tag color='red' style={{ fontSize: '9px'}}>Unsuccessful</Tag> : ""}
                </>
            );
        } else {
            // For other roles, keep original logic
            return (
                <>
                    {outcome === 'success' ? <Tag color='green' style={{ fontSize: '9px'}}>Successful</Tag> : ""}
                    {outcome === 'fail' ? <Tag color='red' style={{ fontSize: '9px'}}>Un-Successful</Tag> : ""}
                    {outcome === 'pending' ? <Tag color='yellow' style={{ fontSize: '9px'}}>Pending</Tag> : ""}
                </>
            );
        }
    };

    const columns: ColumnsType<DataType> = [
        {
            title: 'Date Referred',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
            render: (text) => <>{text && moment(text).format('DD/MM/YYYY')}</>,
        },
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            sorter: (a, b) => a.firstName.localeCompare(b.firstName),
            render: (text) => <>{text}</>,
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            sorter: (a, b) => a.lastName.localeCompare(b.lastName),
            render: (text) => <>{text}</>,
        },
        {
            title: 'Mobile',
            dataIndex: 'mobileNumber',
            key: 'mobileNumber',
            render: (text) => <>{text}</>,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: (a, b) => a.email.localeCompare(b.email),
            render: (text) => <>{text}</>,
        },
        {
            title: 'Business Name',
            dataIndex: 'businessName',
            key: 'businessName',
            render: (text) => {
                return <>{(text || '')}</>
            },
        },
        // {
        //     title: 'Services',
        //     dataIndex: 'rewards',
        //     key: 'rewards',
        //     render: (text) => {
        //         let services = text?.map((item:any, index:number)  => item?.offerName).join(', ')
        //         return services
        //     }
        // },
        {
            title: 'Referred By',
            dataIndex: 'sender',
            key: 'sender',
            sorter: (a: any, b: any) => a?.sender?.contactName?.localeCompare(b?.sender?.contactName),
            render: (text) => <>{ text?.contactName || `${text?.firstName ? text?.firstName : ''} ${text?.lastName ? text?.lastName : ''}`}</>,
        },
        {
            title: 'Contacted date',
            dataIndex: 'contactedDate',
            key: 'contactedDate',
            sorter: (a: any, b: any) => a?.contactedDate?.localeCompare(b?.contactedDate),
            render: (text) => <>{text && moment(text).format('DD/MM/YYYY')}</>,
        },
        {
            title: 'Contacted',
            dataIndex: 'hasSpoken',
            key: 'hasSpoken',
            sorter: (a: any, b: any) => (a?.hasSpoken === b?.hasSpoken ? 0 : a?.hasSpoken ? -1 : 1),
            render: (text) => <>{text === true ? 'Yes' : text === false ? 'No' : '-'}</>,
        },
        {
            title: 'Paid Offer',
            dataIndex: 'paidOffer',
            key: 'paidOffer',
            render: (text) => <>{text}</>,
        },
        {
            title: 'Outcome',
            dataIndex: 'outcome',
            key: 'outcome',
            width: '250',
            sorter: (a: any, b: any) => a?.outcome?.localeCompare(b?.outcome),
            render: (text) => <>{renderOutcomeByRole(text)}</>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record: any) => {
                let isPayButton = record?.businessCode === userData?.data?.businessCode;
                return <Space size="middle">
                    {userRoleId === 3 && 
                    <Link to={'/view-referral'} state={{ isView: true, record, adminId }}>
                        <EyeOutlined style={{ fontSize: '18px', textAlign: 'right', marginLeft: '15px'}} />
                    </Link>}
                    {userRoleId === 1 && record?.outcome === "pending" &&
                    <Button type='default' className='btn btn-outline-primary-md' onClick={() => paymentHandler({ show: true, data: record })}>
                        <BankOutlined /> Pay
                    </Button>
                    }
                    {(userRoleId === 2 && isPayButton) &&
                    <Button type='default' disabled={record?.outcome === "success"} className='btn btn-outline-primary-md' onClick={() => setShowPaymentModal({ show: true, data: record })}>
                        <BankOutlined /> Pay
                    </Button>
                    }
                </Space>
            },
        }
    ];


    const getReferralData =(payload: any)=> {
        payload = {
            page,
            ...payload,
            limit: pageSize, isReferral: 1, role: userRoleId
        };
        if (showOnlyTable) {
            payload = {
                ...payload,
                admin_id: adminId
            }
            delete payload.isReferral
        }

        if (userRoleId === 1) {
            delete payload.isReferral;
            const pathName = location?.pathname?.split('/')?.[2];
            payload.isBusiness = pathName === "my-referrals" ? false : true;
            console.log("get-all-referUs-referrals ::::::::", payload)
            dispatch(
                getAllSuperAdminReferrals(payload, (resp: any) => {
                    if (resp?.success) {
                        setData(resp?.data);
                        setPagination(resp?.pagination);
                    }
                })
            );
        } else {
            dispatch(
                getMyRefferalAction(payload, (resp: any) => {
                    if (resp?.status === 200) {
                        setData(resp?.data);
                        setPagination(resp?.pagination);
                    }
                })
            );
        }
    }

    const sendEmailToReferrer = (value:any) => {
        const payload = {
          referralId: value?.id,
          outcome: true
      }
        dispatch(sendEmailToTheReferrerAction(payload, (res:any)=>{
            getReferralData({})
      }))
      }

    useEffect(() => {
        let payload: PayloadType = {
            limit: pageSize, page, isReferral: 1, role: userRoleId
        };
        getReferralData(payload);
    }, [page, pageSize, dispatch]);

    useEffect(()=> {
        dispatch(updateReferrerNotificationCount({resetType: 'referral', role: userRoleId }, (res:any)=>{
            if(userRoleId === 2) {
                dispatch(getReferrerNotificationCount({}, (res:any)=>{}))
            }
        }))
    }, [])

    const handleTableChange = (pagination: any) => {
        setPage(pagination);
    };

    const paymentHandler =(values:any)=> {
        if(userRoleId ===1) {
            let paymentPayload = {
                outcome: true,
                adminId: values?.data?.adminId, 
                email: values?.data?.email
            }
            dispatch(
                paySuperAdminReferrals(paymentPayload, (resp: any) => {
                    if (resp?.success) {
                        getReferralData({})
                    }
                })
            );
        } else {
            setShowPaymentModal(values);
        }
    }



    const tableComponent = (
        <div className="responsivetable">
            {showOnlyTable ? <Table
                size='small'
                columns={columns}
                dataSource={data}
                loading={isLoading}
                pagination={{
                    total: pagination?.totalItems || 0,
                    pageSize,
                    current: page,
                    showSizeChanger: true,
                    pageSizeOptions: ['20', '50'],
                }}
                scroll={{ y: 264, x: 800 }}
                onChange={handleTableChange}
                rowKey='email'
            /> :
                <>
                    <div className='item-wrapper'>
                        {data?.map((item: any, index: number) => {
                            let itemData = userRoleId === 1 ? convertToReferralBusinessFormat(item) : item;
                            return (
                                <ListingCardReferrer handlEmailSent={(e: any) => sendEmailToReferrer(e)} isReferral={true} handleModal={(inpt: any) => paymentHandler(inpt)} isReferUsNetwork={true} data={itemData} key={index} refetchData={getReferralData} />
                            )
                        })}
                    </div>
                    {data?.length === 0 && <div style={{ textAlign: 'center' }}><Empty /></div>}
                </>
            }
        </div>
    );

    const handleSearch =(data:any)=> {
        let payload = {
            ...data,
            page: 1
        }
        getReferralData(payload);
    }

    const handleExport = () => {
            const payload = { role: userRoleId };
    
            dispatch(
                exportMyReferralsAction(payload, (resp: any) => {
                    if (resp?.status === 200 && resp?.data) {
                        // Create a blob from the response data
                        const blob = new Blob([resp.data], { type: 'text/csv' });
    
                        // Create a download link
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
    
                        // Optional: use Content-Disposition header for filename if available
                        const fileName = `my_referrals_${Date.now()}.csv`;
                        link.setAttribute('download', fileName);
    
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        window.URL.revokeObjectURL(url); // Clean up
    
                        message.success('Export successful!');
                    } else if (resp?.status === 404) {
                        message.warning('No business records found.');
                    } else {
                        message.error('Export failed.');
                    }
                })
            );
        };

    return (
        <div>
            {
                showOnlyTable ? tableComponent :
                    <>
                        <Header pagTitle="Let’s see my referrals" />
                        <div className="contentBody">
                            <div className="bodycard">


                                <div>
                                <PageTitle buttonLabel='Send Referral' pagTitle="My Referrals" button={true} buttonLink={'/send-referral'} />
                                {/* <PageTitle buttonLabel='Send Referral' pagTitle="My Referrals" button={true} exportButton={true} handleExport={handleExport} buttonLink={'/send-referral'} /> */}
                                </div>
                                <div className='pl-24' style={{ float: "right" }}>
                                </div>
                                <div className=''>
                                    <SearchFilter
                                        filterList={referralFilterList}
                                        searchTitle="Name, Email"
                                        onSearch={(searchValue) => {
                                            // Handle the search value here
                                            console.log(searchValue);
                                            handleSearch(searchValue)
                                        }}
                                    />
                                </div>

                                <div className="cardContentbody">
                                    {isLoading ? <Spin style={{ padding: '25px', textAlign: 'center', display: 'block' }}></Spin> : tableComponent}
                                    <div>
                                        <CardPagination activePage={page} total={pagination?.totalItems || 0} handleChange={handleTableChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }

            {/* ******** Referrer and business payment modal **********  */}
            <PaymentModal 
                userData={userData} 
                isReferral={true} 
                visible={showPaymentModal}
                refetchData={getReferralData}
                setVisible={()=>setShowPaymentModal({...showPaymentModal, show: !showPaymentModal})} 
            />

            {/* ******** Super Admin payment modal **********  */}
            <SuperAdminPaymentModal
                userData={userData} 
                isReferral={true} 
                visible={showSuperAdminPaymentModal}
                refetchData={getReferralData}
                setVisible={()=>setShowSuperAdminPaymentModal({...showSuperAdminPaymentModal, show: !showSuperAdminPaymentModal})} 
            />
        </div>
    );
};

export default Referrals;
